import React from "react";

export const checkIfOptinHasLinksAndReturnDescription = (optin) => {
  if (optin?.links?.length) {
    var optinDescriptionWithLink = `${optin.description}`;
    optin.links.map((link) => {
      const anchorTagWithTextAndLink = `
          <a target="_blank" href=${link.uri}>
            ${link.text}
          </a>`;
      optinDescriptionWithLink = optinDescriptionWithLink.replace(
        link.text,
        anchorTagWithTextAndLink
      );
    });
    return (
      <div dangerouslySetInnerHTML={{ __html: optinDescriptionWithLink }} />
    );
  } else {
    const optinDescription = `${optin.description}`;
    return <div dangerouslySetInnerHTML={{ __html: optinDescription }} />;
  }
};

export const isAnyOptInInNullState = (state) => {
  const optInNullStateArray = [];
  Object.keys(state).map((optin) => {
    if (state[optin] === null) {
      optInNullStateArray.push(true);
    }
  });
  return optInNullStateArray.length > 0;
};

export const checkInitialStateForDisableAcceptButton = (state) => {
  const optInNullStateArray = [];
  state.map((optin) => {
    if (optin.checked === null) {
      optInNullStateArray.push(true);
    }
  });
  return optInNullStateArray.length > 0;
};

export const getModuleOptIns = (moduleOptInsList, optIns) => {
  var optInConditionsTempArray = [];
  moduleOptInsList.map((item) => {
    optIns?.conditions_indicated?.filter((condition) => {
      if (Object.keys(item)[0] === condition.condition_type) {
        optInConditionsTempArray.push(condition);
      }
    });
  });
  return optInConditionsTempArray;
};
